<template>
  <v-container fluid class="register-fond">
    <div class="tapiz"></div>
    <v-container style="height:100%">
      <v-layout align-center justify-center fill-heiht style="height:450px">
        <v-flex xs12 sm4>
          <v-card color="white" class="text-xs-centre font-weight-thin">
            <div v-if="token">
              <v-card-text class="mt-5">
                <h1 :class="`text-xs-center font-weight-thin ${classTxt}`">{{ title }}</h1>
              </v-card-text>
              <v-card-text class="contenedor3">
                <v-progress-circular
                  v-if="loading"
                  :size="100"
                  :width="3"
                  color="primary"
                  class="contenido3"
                  indeterminate
                ></v-progress-circular>
                <div class="text-xs-center" style="width:100%" v-if="error"><v-icon class="red--text" size="150" dark>error_outline</v-icon></div>
                <div class="text-xs-center" style="width:100%" v-if="!error && !loading"><v-icon class="green--text" size="150" dark>check_circle_outline</v-icon></div>
              </v-card-text>
              <v-card-text class="mb-5">
                <h2 :class="`text-xs-center font-weight-thin ${classTxt}`">{{ message }}</h2>
              </v-card-text>
            </div>
            <p  v-if="link" class="text-xs-center">Haga click aquí para acceder a su cuenta de usuario:</p>
            <v-card-actions v-if="link">
              <v-btn block color="primary" dark @click="$router.push('/user')">Acceder</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-container>
</template>

<script>
import axios from "axios";
export default {
  name: "Register-Verify-Token",
  data: () => ({
    classTxt: "blue--text",
    title: "Comprobando datos...",
    message: "Por favor, espere.",
    link: false,
    loading: true,
    error: false,
    alert: false,
    errorMessage: ""
  }),
  mounted() {
    this.reset();
    this.checkToken();
  },
  watch: {
    token(newValue, oldValue) {
      this.reset();
    }
  },
  computed: {
    token() {
      return this.$route.params.token || null;
    }
  },
  methods: {
    reset() {
      this.loading = true;
      this.error = false;
      this.link = false;
      this.errorMessage = "";
      this.title = "Comprobando datos...";
      this.message = "Por favor, espere.";
      this.classTxt = "blue--text";
    },
    testFunctions() {
      this.checkToken();
    },
    checkToken() {
      if (!this.token) {
        this.loading = false;
        this.error = true;
        this.errorMessage = "No se puede activar la cuenta de usuario sin un token válido.";
        this.message = this.errorMessage;
        this.alert = true;
        return null;
      }
      const verifyUser = this.$functions.httpsCallable('verifyUser');
      verifyUser(this.token)
        .then((result) => {
          // console.log(result.data);
          this.loading = false;
          this.message = result.data.message;
          if (!result.data.success) {
            this.errorMessage = this.message;
            this.title = "Ha ocurrido un error:";
            this.classTxt = "red--text";
            this.error = true;
            this.alert = true;
            return null;
          }
          this.classTxt = "success--text";
          this.title = "Listo";
          this.link = true;
        })
        .catch((error) => {
          // console.log(error);
          this.message = error.message;
          this.classTxt = "red--text";
        });
    }
  }
};
</script>

<style scoped>
@media (max-width: 640px) and (orientation: landscape) {
  .register-fond {
    background-image: url(../assets/register_640.jpg);
  }
}
@media (min-width: 641px) {
  .register-fond {
    background-image: url(../assets/register_1280.jpg);
  }
}
@media (min-width: 1281px) {
  .register-fond {
    background-image: url(../assets/register_1920.jpg);
  }
}
.tapiz {
  position: absolute;
  width: 100vw;
  height: 100vh;
  background-color: #098519;
  opacity: 0.6;
  margin: 0px;
  padding: 0px;
  top: 0px;
  left: 0px;
}
.contenedor3 {
  display: flex;
  align-items: center;
}
.contenido3 {
  margin: 0 auto; /* requerido para alineación horizontal */
}
</style>
